import heroImg from '@/assets/hero.jpg';

const Hero = () => {
  return (
    <div className="relative min-h-screen overflow-hidden">
      <img src={heroImg} alt="" className="hero-bg-layer size-full object-cover object-center" />
      <div className="hero-overlay bg-black/50" />

      <div className="relative z-20 flex flex-col items-center justify-center px-6 py-24 text-center h-screen">
        <span className="text-purple-400 font-medium mb-4 tracking-widest text-sm">
          HOLDING COMPANY · PRINT-ON-DEMAND PORTFOLIO
        </span>
        <h1 className="text-4xl md:text-6xl font-bold mb-8 max-w-5xl leading-tight">
          We own, operate, and scale{' '}
          <span className="bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent">
            Print-on-Demand
          </span>{' '}
          brands.
        </h1>
        <p className="text-xl md:text-2xl text-gray-200 mb-4 max-w-4xl font-medium">
          AITOS Labs LLC builds, owns, and operates a portfolio of ecommerce POD brands — running on
          our in-house storefront stack, distributed across Etsy, Amazon, and eBay, and powered by
          an AI ops stack for design, listing, fulfillment, and customer experience.
        </p>
        <div className="flex flex-wrap justify-center gap-3 mb-10 max-w-3xl">
          {[
            'In-house Storefront',
            'Design Pipeline',
            'Listing Engine',
            'Marketplace Sync',
            'Fulfillment Router',
            'CX Agent',
          ].map((capability) => (
            <span
              key={capability}
              className="px-4 py-2 rounded-full bg-white/5 border border-white/10 text-gray-300 text-sm md:text-base backdrop-blur-sm hover:bg-white/10 transition-colors"
            >
              {capability}
            </span>
          ))}
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-4 mb-6">
          <a
            href="/brands"
            className="border-2 border-white/30 text-white text-xl font-medium px-12 py-5 rounded-full hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
          >
            See our brand portfolio
          </a>
          <a
            href="/#cta?intent=audit"
            className="bg-gradient-to-r from-indigo-500 to-purple-500 text-white text-xl font-medium px-12 py-5 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            Book a brand audit
          </a>
        </div>
        <p className="text-sm text-gray-400 tracking-wider">
          Currently operating <span className="text-purple-300">elzary.com</span> +{' '}
          <span className="text-pink-300">avyraatlas.com</span> · Wyoming, USA · Print-on-Demand
        </p>
      </div>
    </div>
  );
};

export default Hero;
